import QueryString from "qs";

export const buildServerListUrl = (url: string, query?: Record<string, unknown>) => {
  const queryString = QueryString.stringify(query || {});
  return queryString ? `${url}/?${queryString}` : url;
};
